import apiRequest from "@shared/services/api/apiRequest";

export interface LeaveVideoRoomRequest {
  room_id: number;
}

export interface LeaveVideoRoomResponse {
  message: string;
  room_id: number;
  room_ended: boolean;
}

export const leaveVideoRoom = async (request: LeaveVideoRoomRequest): Promise<LeaveVideoRoomResponse> => {
  return apiRequest("/api/video-rooms/leave/", "POST", request);
}; 